import { Component, Input, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { environment } from 'src/environments/environment';
import { ConsultationLinkWithAbhaComponent } from '../../pro/consulatation/consulatation/consultation-link-with-abha/consultation-link-with-abha.component';

@Component({
  selector: 'app-documents-upload-modal',
  templateUrl: './documents-upload-modal.component.html',
  styleUrls: ['./documents-upload-modal.component.css'],
  providers: [DatePipe]
})
export class DocumentsUploadModalComponent implements OnInit {

  @Input() beneficiaryId: number;   // pass patient beneficiary id when opening modal
  @Input() memberId: number = 0;    // pass member id if family member, else 0
  @Input() patientDetails: any;

  // ── List View ──
  openDocumentAdd: boolean = false;
  dtRender: boolean = false;
  documentList: any[] = [];

  // ── Filter fields ──
  fromDate = new Date();
  toDate = new Date();
  selectedFileTypeId: any = '';
  maxDate: Date = new Date();

  // ── File types ──
  fileTypeList: any[] = [];
  allFileTypeIds: number[] = [];

  // ── Upload fields ──
  uploadReportDate = new Date();
  uploadFileType: any = '';
  selectedFile: File = null;
  patientName :any;
  screenName:any;
  careContextHide: boolean = false;
  isNDHMEnable: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private masterService: MasterService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private http: HttpClient,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.getFeaturePermission();
    this.patientName = this.patientDetails?.fullname
    this.screenName = this.patientDetails?.relation.toLowerCase() === 'self' ? 'BENEFICIARY' : 'MEMBERDOCUMENTS'
    this.getAllFileTypes();
  }

    getFeaturePermission(){
    var featureList:any = JSON.parse(localStorage.getItem('featuresList'));
    if(localStorage.featuresList){
      for (let i = 0; i < featureList.length; i++) {
     
        if (featureList[i].feature_id.feature_name == "careContextHide") {
          if(featureList[i].patient){
            this.careContextHide = true;
          } else{
            this.careContextHide = false;
          }
        }

        if (featureList[i].feature_id.feature_name == "isNDHMEnable") {
          if(featureList[i].patient){
            this.isNDHMEnable = true;
          } else{
            this.isNDHMEnable = false;
          }
        }
    
  }
    }
   

  }

  // ── Step 1: Load category types, then load all docs ──
  getAllFileTypes() {
    this.masterService.getAll('getbycategoryid/4').subscribe({
      next: (res: any) => {
        if (res.status === 'OK') {
          this.fileTypeList = res.data ?? [];
          this.allFileTypeIds = this.fileTypeList.map((ft: any) => ft.id);
          this.fetchDocuments();
        } else {
          this.toastr.error(res.message);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      }
    });
  }

  // ── Load all documents (default on open) ──
 



  // ── Common API call for fetching documents ──
  fetchDocuments() {
    const fileTypeIds = this.selectedFileTypeId
      ? [Number(this.selectedFileTypeId)]
      : this.allFileTypeIds;

    const payload = {
      beneficiary_id: this.beneficiaryId,
      file_type_id: fileTypeIds,
      from_date: this.datePipe.transform(this.fromDate, 'yyyy-MM-dd'),
      member_id: this.memberId ?? 0,
      page: 0,
      search_string: '',
      size: 10000,
      to_date: this.datePipe.transform(this.toDate, 'yyyy-MM-dd')
    };
    this.dtRender = false;
    this.documentList = [];
    this.regService.post('registration/jwt/beneficiary/getbeneficiarydocuments', payload).subscribe({
      next: (res: any) => {
        if (res.status === 'OK') {
          this.documentList = res.data.content ?? [];
          // this.documentList.forEach((e:any) => {
          //   e.health_id =  this.patientDetails?.health_id
          //   e.health_id_number = this.patientDetails?.health_id_number
          // });
        } else {
          this.toastr.error(res.message);
        }
        setTimeout(() => { this.dtRender = true; }, 100);
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
        setTimeout(() => { this.dtRender = true; }, 100);
      }
    });
  }

  // ── View Document ──
  viewDocument(doc: any) {
    if (doc?.entire_document_path) {
   let webURL = location.href.includes('localhost') ? environment.applicationURL : location.origin;
      let path =  webURL + doc?.entire_document_path
      window.open(path, '_blank');
    } else {
      this.toastr.warning('No file path available to view.');
    }
  }

  // ── Download Document ──
  downloadDocument(doc: any) {
    if (!doc?.entire_document_path) {
      this.toastr.warning('No file available to download.');
      return;
    }
    const webURL = location.href.includes('localhost') ? environment.applicationURL : location.origin;
    const fileUrl =  doc.entire_document_path;
    const fileName = doc.file_name || 'document';

    this.http.get(fileUrl, { responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      },
      error: () => {
        this.toastr.error('Failed to download the file.');
      }
    });
  }

  // ── Delete Document ──
  deleteDocument(doc: any) {
    if (!confirm('Are you sure you want to delete this document?')) return;
    this.regService.get(`registration/jwt/beneficiary/deletebeneficiarydocumentbyid?id=${doc.document_id}`).subscribe({
      next: (res: any) => {
        if (res.status === 'OK' || res.status === 'success') {
          this.toastr.success(res.message || 'Document deleted successfully.');
          this.fetchDocuments();
        } else {
          this.toastr.error(res.message);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      }
    });
  }

  // ── File selection ──
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  // ── Cancel Upload ──
  cancelUpload(type:any) {
    if(type === 'back'){
     this.openDocumentAdd = false;
    }
    
    this.uploadReportDate = new Date();
    this.uploadFileType = '';
    this.selectedFile = null;
  }


  // ── Submit Upload ──
  submitUpload() {
    if (!this.uploadReportDate) {
      this.toastr.error('Please select a report date.');
      return;
    }
    if (!this.uploadFileType) {
      this.toastr.error('Please select a file type.');
      return;
    }
    if (!this.selectedFile) {
      this.toastr.error('Please select a file to upload.');
      return;
    }

    const reportDate = this.uploadReportDate.toString().includes('Standard')
      ? this.datePipe.transform(this.uploadReportDate, 'yyyy-MM-dd')
      : this.uploadReportDate;

    const tenantId = sessionStorage.getItem('TENANT_ID') || sessionStorage.getItem('currentTenant');
    let doctorDetails = JSON.parse(sessionStorage.getItem('DoctorDetails'));
    const formData = new FormData();
    formData.append('file', this.selectedFile, this.selectedFile.name);
    formData.append('fileTypeId', String(this.uploadFileType));
    formData.append('isActive', 'true');
    formData.append('screenName', this.screenName);
    formData.append('doctor_id', doctorDetails?.id);
    formData.append('reg_id', String(this.beneficiaryId));
    formData.append('report_date', this.datePipe.transform(reportDate,'yyyy-MM-dd'));

    this.regService.postWithoutTnt(`file-service/jwt/file/upload?TENANT_ID=${tenantId}`, formData).subscribe({
      next: (res: any) => {
        if (res.status === 'success' || res.status === 'OK') {
          this.toastr.success('Document uploaded successfully.');
          this.cancelUpload('back');
          this.fetchDocuments();
        } else {
          this.toastr.error(res.message || 'Upload failed.');
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      }
    });
  }

  openLinkwithAbhaConsultation(item) {
        const modalRef = this.modalService.open(ConsultationLinkWithAbhaComponent, { scrollable: true, size: 'xl' });
        modalRef.componentInstance.data = item;
         modalRef.componentInstance.hiType = 'HealthDocumentRecord';
        modalRef.componentInstance.title = 'Link Care context with ABHA';
        modalRef.result.then(result => {
          // if (result == 'changes saved'){
            this.fetchDocuments();
           
          // } 
        }, (reason) => { });
  }
}
